import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { TokenProvider } from "./context/tokenContext";
import App from "./App";
import "../src/css/App.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { clearStorageOnNewVersion } from "./services/Utils/versionGuard";
import "./i18n/i18n";

// Purge le localStorage/sessionStorage si une nouvelle version de l'app a été
// déployée, avant toute initialisation de MSAL (évite par exemple un verrou
// "interaction_in_progress" hérité d'une version précédente incompatible).
clearStorageOnNewVersion();

const googleId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
const officeId = import.meta.env.VITE_OFFICE_CLIENT_ID;
const redirectUri = import.meta.env.VITE_OFFICE_REDIRECT_URI;

const msalConfig = {
  auth: {
    clientId: officeId,
    authority: `https://login.microsoftonline.com/common`,
    // Depuis MSAL Browser v5, redirectUri DOIT pointer vers la page pont
    // "redirect.html" (voir /redirect.html à la racine du projet) à cause du
    // support Cross-Origin-Opener-Policy. VITE_OFFICE_REDIRECT_URI doit donc
    // être mis à jour (ex: "https://mondomaine.fr/redirect.html") ET cette
    // même URI doit être déclarée dans l'inscription d'application Entra ID.
    redirectUri: redirectUri,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <GoogleOAuthProvider clientId={googleId}>
    <MsalProvider instance={msalInstance}>
      <React.StrictMode>
        <BrowserRouter>
          <TokenProvider>
            <App />
          </TokenProvider>
        </BrowserRouter>
      </React.StrictMode>
    </MsalProvider>
  </GoogleOAuthProvider>
);
